<ng-container *ngIf="manager; else public">
  <div class="row">
    <div class="col-xs-12 col-sm-6 form-group" *ngFor="let fieldConfig of getFields()" [formGroup]="group">
      <ng-container *ngIf="group.get(fieldConfig.id) && fieldAvailable(fieldConfig)">
        <label
          *ngIf="fieldConfig.type !== fieldTypes.select && fieldConfig.type !== fieldTypes.multiSelect"
          for="field-{{fieldConfig.id}}"
          class="control-label"
        >{{fieldConfig.name}}</label>
        <input
          *ngIf="fieldConfig.type !== fieldTypes.select && fieldConfig.type !== fieldTypes.multiSelect && fieldConfig.type !== fieldTypes.date && fieldConfig.type !== fieldTypes.tel"
          [id]="'field-' + fieldConfig.id"
          [type]="fieldConfig.type"
          class="form-control"
          [placeholder]="fieldConfig.placeholder || ''"
          [formControlName]="fieldConfig.id"
        >

        <ng-container *ngIf="fieldConfig.type === fieldTypes.tel">
          <input
            [id]="'field-' + fieldConfig.id"
            type="tel"
            pattern="[\-+\(\)\s\d]*"
            class="form-control"
            [placeholder]="fieldConfig.placeholder"
            [formControlName]="fieldConfig.id"
            [value]="group.get(fieldConfig.id).value | trTel: country"
          />
        </ng-container>

        <ng-container *ngIf="fieldConfig.type === fieldTypes.date">
          <input
            [id]="'field-' + fieldConfig.id"
            [placeholder]="fieldConfig.placeholder"
            class="form-control"
            type="text"
            ngbDatepicker
            container="body"
            [weekdays]="true"
            [firstDayOfWeek]="7"
            #datepicker="ngbDatepicker"
            name="date"
            [formControlName]="fieldConfig.id"
            (click)="datepicker.toggle()"
          />
        </ng-container>

        <ng-container *ngIf="fieldConfig.type === fieldTypes.select || fieldConfig.type === fieldTypes.multiSelect">
          <frontend-dropdown-clear [dropdown]="fieldDropdown">
            <label for="field-{{fieldConfig.id}}" class="control-label">{{fieldConfig.name}}</label>
          </frontend-dropdown-clear>
          <frontend-dropdown
            #fieldDropdown
            data-dd-privacy="mask"
            [elementId]="'field-' + fieldConfig.id"
            [formControlName]="fieldConfig.id"
            [placeholder]="fieldConfig.placeholder || fieldConfig.name"
            [items]="fieldConfig.options"
            [forceMobileDropdown]="!publicPages"
            [forceDesktopDropdown]="publicPages"
            [multiple]="fieldConfig.type === fieldTypes.multiSelect"
            [addTag]="false"
            [clearable]="true"
            [plainValues]="true"
            [inlineClearButton]="false"
          ></frontend-dropdown>
        </ng-container>
        <control-messages [control]="group.get(fieldConfig.id)"></control-messages>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #public>
  <div class="form-group" *ngFor="let fieldConfig of getFields()" [formGroup]="group">
    <div class="input-group" *ngIf="group.get(fieldConfig.id) && fieldAvailable(fieldConfig)">
      <span
        class="bi input-group-addon tr-public-addon"
        [class.bi-fonts]="fieldConfig.type === fieldTypes.text"
        [class.bi-menu-button-wide]="fieldConfig.type === fieldTypes.select || fieldConfig.type === fieldTypes.multiSelect"
        [class.bi-calendar-date]="fieldConfig.type === fieldTypes.date"
        [class.bi-telephone]="fieldConfig.type === fieldTypes.tel"
        [class.bi-123]="fieldConfig.type === fieldTypes.number"
        [class.bi-envelope]="fieldConfig.type === fieldTypes.email"
        [class.bi-link-45deg]="fieldConfig.type === fieldTypes.url"
      ></span>
      <input
        *ngIf="fieldConfig.type !== fieldTypes.select && fieldConfig.type !== fieldTypes.multiSelect && fieldConfig.type !== fieldTypes.date && fieldConfig.type !== fieldTypes.tel"
        [type]="fieldConfig.type"
        [formControlName]="fieldConfig.id"
        [placeholder]="fieldConfig.placeholder || ''"
        [attr.aria-label]="fieldConfig.name"
        [attr.autocomplete]="fieldConfig.type === fieldTypes.email ? 'email' : null"
        class="form-control"
      />

      <ng-container *ngIf="fieldConfig.type === fieldTypes.tel">
        <input
          [id]="'field-' + fieldConfig.id"
          type="tel"
          class="form-control"
          [placeholder]="fieldConfig.placeholder"
          [attr.aria-label]="fieldConfig.name"
          [formControlName]="fieldConfig.id"
          appPhonePatternCountryValidator="phone"
          [phoneCountry]="'UA'"
          [value]="group.get(fieldConfig.id).value | trTel: country"
        />
      </ng-container>

      <ng-container *ngIf="fieldConfig.type === fieldTypes.date">
        <input
          [id]="'field-' + fieldConfig.id"
          [placeholder]="fieldConfig.placeholder"
          [attr.aria-label]="fieldConfig.name"
          class="form-control custom-datepicker"
          type="text"
          ngbDatepicker
          container="body"
          [weekdays]="true"
          [firstDayOfWeek]="7"
          #datepicker="ngbDatepicker"
          name="date"
          [formControlName]="fieldConfig.id"
          (click)="datepicker.toggle()"
        />
      </ng-container>

      <ng-container *ngIf="fieldConfig.type === fieldTypes.select || fieldConfig.type === fieldTypes.multiSelect">
        <frontend-dropdown
          [elementId]="'field-' + fieldConfig.id"
          [formControlName]="fieldConfig.id"
          [placeholder]="fieldConfig.placeholder || fieldConfig.name"
          [items]="fieldConfig.options"
          [forceMobileDropdown]="!publicPages"
          [forceDesktopDropdown]="publicPages"
          [multiple]="fieldConfig.type === fieldTypes.multiSelect"
          data-dd-privacy="mask"
          class="custom-dropdown"
          [addTag]="false"
          [plainValues]="true"
          [clearable]="true"
        ></frontend-dropdown>
      </ng-container>
    </div>
    <control-messages [control]="group.get(fieldConfig.id)"></control-messages>
  </div>
</ng-template>
